import { useSyncExternalStore } from "react";

/**
 * Reactive online/offline status from the browser.
 *
 * `navigator.onLine` is a coarse signal (it only knows whether a network
 * interface exists, not whether the internet is actually reachable), but it's
 * the right primitive for "should I even attempt a write" — and the queue's
 * replay-on-failure logic covers the false-positive case where onLine is true
 * but the request still fails.
 */
function subscribe(callback: () => void): () => void {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true, // SSR / first paint: assume online
  );
}
